const txWeekDays = idDiaSemana => {
  const weekDays = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
  return weekDays[idDiaSemana - 1];
}

export default txWeekDays;
